import { render, staticRenderFns } from "./communicateLog.vue?vue&type=template&id=37cc7122&scoped=true&"
import script from "./communicateLog.vue?vue&type=script&lang=js&"
export * from "./communicateLog.vue?vue&type=script&lang=js&"
import style0 from "./communicateLog.vue?vue&type=style&index=0&id=37cc7122&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cc7122",
  null
  
)

export default component.exports